import { useState, useCallback } from "react";
import { BuildQuotesStates } from "../../enums/BuildQuoteStates";

export const useBuildQuoteState = () => {
  const [isEstimateEdit, setIsEstimateEdit] = useState(false);
  const [isQuoteEdit, setIsQuoteEdit] = useState(false);
  const [showEstimate, setShowEstimate] = useState<BuildQuotesStates>(
    BuildQuotesStates.IS_ESTIMATE
  );
  const [estimateTickedRows, setEstimateTickedRows] = useState([]);
  const [quoteTickedRows, setQuoteTickedRows] = useState([]);

  const handleToggleShowEstimate = useCallback(
    (currentButton: string) => {
      if (isQuoteEdit || isEstimateEdit) return;

      setIsEstimateEdit(false);
      setIsQuoteEdit(false);
      setEstimateTickedRows([]);
      setQuoteTickedRows([]);

      if (currentButton === BuildQuotesStates.IS_QUOTE) {
        setShowEstimate(BuildQuotesStates.IS_QUOTE);
      } else if (currentButton === BuildQuotesStates.IS_ESTIMATE) {
        setShowEstimate(BuildQuotesStates.IS_ESTIMATE);
      }
    },
    [isQuoteEdit, isEstimateEdit]
  );

  const resetEditStates = useCallback(() => {
    setIsEstimateEdit(false);
    setIsQuoteEdit(false);
  }, []);

  return {
    isEstimateEdit,
    isQuoteEdit,
    showEstimate,
    estimateTickedRows,
    quoteTickedRows,
    setIsEstimateEdit,
    setIsQuoteEdit,
    setShowEstimate,
    setEstimateTickedRows,
    setQuoteTickedRows,
    handleToggleShowEstimate,
    resetEditStates,
  };
};
